import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

export default function RedExclamationCircle () {
  return (
    <div className="pointer-events-none inset-y-0 right-0 flex items-center pr-3">
      <ExclamationCircleIcon className="h-6 w-6 text-red-500" aria-hidden="true"/>
    </div>
    );
}
